<body
  class="home page-template page-template-page-templates page-template-home_2024 page-template-page-templateshome_2024-php page"
>
  <myqq-unauth-header *ngIf="!isLoggedIn"></myqq-unauth-header>
  <myqq-auth-header *ngIf="isLoggedIn"></myqq-auth-header>

  <div class="page-wrapper" role="main">
    <div class="menu-spacer"></div>
    <section class="ipad-fix">
      <div class="container-fluid p-0">
        <div class="banner-override hide-on-desktop pt-0">
          <a routerLink="/plans"
            ><img
              alt="Sale and Promo Banner"
              fetchpriority="high"
              src="{{cdnHost}}/img/LP_Desktop_Top_Banner.png"
            />
          </a>
        </div>
        <div class="banner-override hide-on-mobile pt-0">
          <a routerLink="/plans"
            ><img
              alt="Sale and Promo Banner"
              fetchpriority="high"
              src="{{cdnHost}}/img/LP_Desktop_Top_Banner.png"
              width="1280"
            />
          </a>
        </div>
      </div>
    </section>
    <section class="image-text-block home-zip-block">
      <div class="container">
        <div class="fld-dsk-row row align-items-center">
          <div class="col-12 col-lg-6 text-center mr-auto">
            <h1 class="mb-3 px-0 px-xl-5">More Than 250 Car Wash Locations</h1>
            <p class="font-quicksand mb-3 mb-md-4">
              Quick Quack is a thriving network of local express car washes
            </p>
            <p class="h3 find-location d-inline-block font-quicksand mb-3">
              Find a location near you!
            </p>
            <div class="clearfix w-100"></div>
            <div class="search-box see-plans mb-4 mb-md-5">
              <input
                type="text"
                name="zipcode"
                (keyup.enter)="handleLocationsSearch()"
                [formControl]="zipcode"
                placeholder="Enter ZIP code"
                id="zipcode2"
                pattern="[0-9]{5}"
                required="required"
                aria-label="Enter Zip Code"
                title="Five digit zip code"
              />
              <button type="submit" (click)="handleLocationsSearch()">
                Search
              </button>
            </div>
            <p class="font-quicksand">
              Arizona • California • Colorado • Texas • Utah
            </p>
          </div>
          <div class="col-12 col-lg-6 mb-4 mb-lg-0">
            <div class="image">
              <img
                src="{{cdnHost}}/img/LP_QQ_Store.png"
                alt="Quick Quack car wash"
                title="Quick Quack building"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="shine-on-unlimited-membership">
      <h2>Shine On with an Unlimited Car Membership</h2>
      <h3>With Every Wash, At Every Location</h3>
      <div class="container text-center py-4 py-md-4 py-xl-4 bigger-z-index">
        <div class="row align-items-start">
          <div class="col-md-4 shine-on-padding">
            <img src="{{cdnHost}}/img/LP_Triple_Foam.svg" />
            <p class="h3">Triple Foam Wash</p>
          </div>
          <div class="col-md-4 shine-on-padding">
            <img src="{{cdnHost}}/img/LP_Rush_Inhibitor.svg" />
            <p class="h3">Undercarriage Rust Inhibitor</p>
          </div>
          <div class="col-md-4 shine-on-padding">
            <img src="{{cdnHost}}/img/LP_Free_Vacuums.svg" />
            <p class="h3">Free Vacuums*</p>
          </div>
        </div>
        <a routerLink="{{whyMembershipLink}}" class="shine-on-button"
          >Learn More</a
        >
      </div>
    </section>
    <section>
      <div>
        <section class="testimonial-section">
          <div>
            <h2>See What People Are Saying About Quick Quack!</h2>
          </div>
          <app-carousel [reviews]="reviews"></app-carousel>
        </section>
        <section class="experience-section">
          <h2>The Quick Quack Experience</h2>
          <ng-image-slider
            #nav
            [images]="experiences"
            [infinite]="true"
            [autoSlide]="1"
            [showArrow]="true"
            [imagePopup]="false"
            [imageSize]="{width: 415, height: 276, space:10}"
            [slideImage]="1"
          ></ng-image-slider>
        </section>
        <section class="save-section">
          <h2>Save Time, Save Water, Save Money</h2>
          <div class="fld-dsk-row flg-7">
            <div>
              <img
                loading="lazy"
                src="{{cdnHost}}/img/LP_Save_Time.svg"
                class="attachment-full size-full"
                alt="Quick Quack save time"
              />
              <h3>Get cleaned, dried and shined in three minutes or less</h3>
            </div>
            <div>
              <img
                loading="lazy"
                src="{{cdnHost}}/img/LP_Save_Water.svg"
                class="attachment-full size-full"
                alt="Quick Quack save water"
              />
              <h3>We reclaim and recycle 99% of the water used in each wash</h3>
            </div>
            <div>
              <img
                loading="lazy"
                src="{{cdnHost}}/img/LP_Save_Money.svg"
                class="attachment-full size-full"
                alt="Quick Quack save money"
              />
              <h3>Save on every wash with an unlimited membership</h3>
            </div>
          </div>
        </section>
      </div>
    </section>
    <section class="become-member-2024-block container-fluid p-0">
      <div class="container-fluid p-0">
        <div class="box">
          <div class="text">
            <div class="search-box see-plans">
              <input
                type="text"
                name="zipcode"
                (keyup.enter)="handlePlansSearch()"
                [formControl]="zipcode"
                placeholder="Enter ZIP code"
                id="zipcode7"
                pattern="[0-9]{5}"
                required="required"
                aria-label="Enter Five Digit Zip Code"
                title="Five digit zip code"
              />
              <button type="submit" (click)="handlePlansSearch()">
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <myqq-unauth-footer></myqq-unauth-footer>
  </div>
</body>
